import type { InkColorLookup } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { TEXT_OPTION_ID_FALLBACK_CLASS } from './text-option-id-fallback';

interface QuoteInkLabelProps {
  readonly inkColorId: string;
  /** 이름 찾기 결과 — 불러오는 중·실패·못 찾은 id 면 undefined. */
  readonly inkColor: InkColorLookup | undefined;
}

/** 견적 사본의 잉크 하나 — 견본·이름·색상 코드(지운 잉크는 '(삭제됨)'), 이름을 모르면 id 를 그대로 보여 준다. */
export const QuoteInkLabel = ({ inkColorId, inkColor }: QuoteInkLabelProps): ReactElement => {
  if (inkColor === undefined) {
    return <span className={TEXT_OPTION_ID_FALLBACK_CLASS}>{inkColorId}</span>;
  }

  return (
    <span title={inkColorId} className="inline-flex flex-wrap items-center gap-1.5">
      {/* 테두리를 둬 흰색 계열 잉크도 보이게 한다. 이름·코드가 바로 옆 글자로 있으므로 견본은 꾸밈이다(이름을 두 번 읽지 않는다). */}
      <span
        aria-hidden
        className="inline-block size-4 shrink-0 rounded-full border shadow-inner"
        style={{ backgroundColor: inkColor.colorCode }}
      />
      <span>{inkColor.name}</span>
      <span className="font-mono text-xs text-muted-foreground">{inkColor.colorCode}</span>
      {inkColor.deleted ? <span className="text-xs text-destructive">(삭제됨)</span> : null}
    </span>
  );
};
